import { Card, CardHeader, Row, CardBody } from 'reactstrap';
import { successMsg,errorMsg } from '../../cache/vars';
import { CRYPTO_JS_SECRET } from '../../utils/constants';
import PackageInfoActionButtons from './PackageInfoActionButtons';
import PackageInfoCartFilters from './PackageInfoCartFilters';
import CryptoJS from 'crypto-js/aes';
import moment from 'moment';
import { useApolloClient } from '@apollo/client';
import { SEND_TEMPLATE_EMAIL, SAVE_SEND_DETAILS_EMAIL_LOG } from '../../queries/vip-workflow';

const PackageMenu = ({
  packageOrderWithDetails,
  activeCardsFilter,
  setActiveCardsFilter,
  availableFilters,
  isSendDetailsEmailLogsModalOpened,
  setIsSendDetailsEmailLogsModalOpened,
  user,
}: any) => {
  const client = useApolloClient();
  return (
    <Card style={{ marginBottom: '15px' }}>
      <CardHeader>
        <Row className="ml-2 mt-1">
          <h1 className="m-0">{packageOrderWithDetails?.eventName}</h1>
        </Row>
        <Row className="ml-2">
          <span className="m-0">
            {packageOrderWithDetails?.eventDate?.includes('3:30 am')
              ? packageOrderWithDetails.eventDate.replace('3:30 am', 'Time TBD')
              : packageOrderWithDetails?.eventDate}
          </span>
        </Row>
        <Row className="ml-2 mt-3">
          <span className="m-0" style={{ color: '#807979' }}>
            {packageOrderWithDetails?.venueCity}, {packageOrderWithDetails?.venue} (
            {packageOrderWithDetails?.venueAddress})
          </span>
        </Row>
      </CardHeader>
      <CardBody className="d-flex flex-column">
        <Row className="ml-0 mr-0 ml-2 mb-1">
          <h2 className="m-0">
            {packageOrderWithDetails?.section} {packageOrderWithDetails?.row}
          </h2>
        </Row>
        <Row className="ml-2 mr-0">
          {moment(packageOrderWithDetails?.startDate, 'MMMM Do YYYY').toLocaleString() ===
          moment(packageOrderWithDetails?.endDate, 'MMMM Do YYYY').toLocaleString()
            ? packageOrderWithDetails?.startDate
            : packageOrderWithDetails?.startDate + ' - ' + packageOrderWithDetails?.endDate}
        </Row>
        <Row className="ml-2 mt-2">
          <span>{packageOrderWithDetails?.recipient}</span>
        </Row>
        <Row className="ml-2">
          <span>{packageOrderWithDetails?.recipientEmail}</span>
        </Row>
        <Row className="ml-2 mt-2 d-flex flex-column">
          <span className="m-0">
            Invoice Id:&nbsp;
            {packageOrderWithDetails?.invoiceId}
          </span>
          <span className="m-0">
            Purchase Order ID:&nbsp;
            {packageOrderWithDetails?.purchaseOrderId || '-'}
          </span>
          <span className="m-0">
            Order ID:&nbsp;
            {packageOrderWithDetails?.externalPo || '-'}
          </span>
        </Row>
        <Row className="ml-2 mt-2">
          <button
            className="m-0 btn btn-sm btn-primary"
            onClick={async () => {
              const encryptedInvoiceId = CryptoJS.encrypt(
                `${packageOrderWithDetails?.invoiceId}`,
                CRYPTO_JS_SECRET,
              ).toString();

              const encryptedInvoiceIdWithReplacedSlashes = encryptedInvoiceId.replace(
                /\//g,
                'HjsOwpeSBqdLafaFsjhHfd73sb7kdheYTsd61',
              );

              const invoiceLink: string = `https://${process.env.REACT_APP_APPLICATION_HOST}/package-info/${encryptedInvoiceIdWithReplacedSlashes}`;
              navigator.clipboard.writeText(invoiceLink);
              successMsg('Copied to clickboard');
            }}
          >
            <i className="fa fa-copy"></i>&nbsp;&nbsp; Share link with Client
          </button>
        </Row>
        <Row className="ml-2 mt-2">
          <button
            className="m-0 btn btn-sm btn-primary"
            onClick={async () => {
              const encryptedInvoiceId = CryptoJS.encrypt(
                `${packageOrderWithDetails?.invoiceId}`,
                CRYPTO_JS_SECRET,
              ).toString();

              const encryptedInvoiceIdWithReplacedSlashes = encryptedInvoiceId.replace(
                /\//g,
                'HjsOwpeSBqdLafaFsjhHfd73sb7kdheYTsd61',
              );

              const invoiceLink: string = `https://${process.env.REACT_APP_APPLICATION_HOST}/package-info/${encryptedInvoiceIdWithReplacedSlashes}`;
              // navigator.clipboard.writeText(invoiceLink);
              try {
                const templateVariables = {
                  link: invoiceLink,
                  eventName: packageOrderWithDetails?.eventName,
                };
                if (!packageOrderWithDetails.recipientEmail) {
                 return errorMsg('Recipient email is missing or invalid');
                }
                const data = await client.mutate({
                  mutation: SEND_TEMPLATE_EMAIL,
                  variables: {
                    to: packageOrderWithDetails?.recipientEmail,
                    subject: `Your ${packageOrderWithDetails?.eventName} Package Details Are Ready`,
                    templateName: 'vip-package-invoice-template',
                    variables: JSON.stringify(templateVariables),
                  },
                  fetchPolicy: 'network-only',
                });
                if (data) {
                  await client.mutate({
                    mutation: SAVE_SEND_DETAILS_EMAIL_LOG,
                    variables: {
                      data: {
                        invoiceId: packageOrderWithDetails?.invoiceId,
                        user: user,
                        createdAt: new Date().toISOString(),
                      },
                    },
                  });
                }
                console.log('Email sent response:', data);
                successMsg('Mail sent successfully');
              } catch (error: any) {
                console.error('Email send error:', error);
                console.error('Error details:', {
                  message: error.message,
                  graphQLErrors: error.graphQLErrors,
                  networkError: error.networkError,
                });
              }
            }}
          >
            <i className="fa fa-envelope"></i>&nbsp;&nbsp; Send Delivery Detail
          </button>

          <button
            className="ml-2 btn btn-sm btn-primary"
            title="Delivery Detail Email Logs"
            onClick={() => {
              setIsSendDetailsEmailLogsModalOpened(true);
            }}
          >
            <i className="fas fa-lg fa-history"></i>
          </button>
        </Row>
        <PackageInfoActionButtons />
        <PackageInfoCartFilters
          activeCardsFilter={activeCardsFilter}
          setActiveCardsFilter={setActiveCardsFilter}
          availableFilters={availableFilters}
        />
      </CardBody>
    </Card>
  );
};

export default PackageMenu;
